/**
 * app-search — tipos + validador del search-state global del layout `_app`.
 *
 * Por ahora sólo centraliza el flag multi-cuenta (`?account=switch`) que abre el
 * `AccountSwitcher` (campaña #18). El switcher se monta UNA vez a nivel layout
 * (`AccountSwitcherHost`) y es addressable por URL, así que pegar la URL reabre
 * el overlay. `validateSearch` omite defaults (no contamina la URL vacía).
 */

export interface AppLayoutSearch {
  /** Switcher de cuentas abierto (`?account=switch`). Multi-cuenta #18. */
  account?: "switch";
}

export function validateAppLayoutSearch(raw: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};
  if (raw.account === "switch") {
    out.account = "switch";
  }
  return out;
}
